/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLightbulb = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.003 2C15.888 2 19 5.283 19 9.223c0 1.868-.686 3.772-2.102 5.15l-.006.005-.006.005c-.587.554-.884 1.36-.884 2.228V17H16v1a4 4 0 1 1-8 0v-1.555c-.043-.76-.377-1.537-.99-2.174a7.158 7.158 0 0 1-2.004-5.326v-.002C5.18 5.181 8.202 2.092 11.903 2zM10 18a2 2 0 0 0 4 0v-1h-4zm1.71-13.988c-2.49.19-4.582 2.339-4.705 5.023a5.158 5.158 0 0 0 1.445 3.849A5.603 5.603 0 0 1 9.739 15h1.26v-4h2v4h1.242a4.743 4.743 0 0 1 1.273-2.072C16.49 11.973 17 10.615 17 9.223 17 6.318 14.714 4 12.003 4h-.05z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLightbulb as Lightbulb };
